import React, { createContext, useContext, useState, useEffect } from 'react'

const ThemeContext = createContext()

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}

export const ThemeProvider = ({ children }) => {
  const [mainCategory, setMainCategory] = useState(() => {
    // 从sessionStorage读取，如果没有则默认为'all'
    return sessionStorage.getItem('theme-mainCategory') || 'all'
  })

  // 根据主分类设置页面色调（柔和舒适的配色）
  const getThemeClasses = () => {
    if (mainCategory === 'male') {
      return {
        bg: 'bg-gradient-to-br from-slate-900/40 via-slate-800/30 to-slate-900/40',
        bgOverlay: 'bg-slate-900/5',
        primary: 'from-slate-500 to-slate-600',
        primaryHover: 'hover:from-slate-600 hover:to-slate-700',
        accent: 'text-slate-300',
        border: 'border-slate-600/20',
        cardBg: 'bg-slate-900/20',
        navBg: 'bg-slate-900/95',
        bodyBg: 'from-slate-950 via-slate-900 to-slate-950'
      }
    } else if (mainCategory === 'female') {
      return {
        bg: 'bg-gradient-to-br from-rose-950/15 via-pink-950/10 to-rose-950/15',
        bgOverlay: 'bg-rose-950/5',
        primary: 'from-rose-400 to-pink-400',
        primaryHover: 'hover:from-rose-500 hover:to-pink-500',
        accent: 'text-rose-300',
        border: 'border-rose-500/20',
        cardBg: 'bg-rose-950/15',
        navBg: 'bg-dark-900/95',
        bodyBg: 'from-rose-950/10 via-pink-950/5 to-rose-950/10'
      }
    }
    return {
      bg: 'bg-dark-900',
      bgOverlay: 'bg-dark-800/50',
      primary: 'from-primary to-secondary',
      primaryHover: 'hover:from-primary/90 hover:to-secondary/90',
      accent: 'text-primary',
      border: 'border-primary/30',
      cardBg: 'bg-dark-800/50',
      navBg: 'bg-dark-900/95',
      bodyBg: 'bg-dark-900'
    }
  }

  // 当主题变化时，更新sessionStorage（不再修改body背景，只影响主要内容区）
  useEffect(() => {
    sessionStorage.setItem('theme-mainCategory', mainCategory)
    
    // 保持body和html为默认深色背景，不随主题变化
    const body = document.body
    const html = document.documentElement
    
    // 确保body和html保持默认深色背景
    if (!body.style.background || body.style.background === '') {
      body.style.background = '#0f172a'
      html.style.background = '#0f172a'
    }
    
    body.style.minHeight = '100vh'
    html.style.minHeight = '100vh'
  }, [mainCategory])

  const value = {
    mainCategory,
    setMainCategory,
    theme: getThemeClasses()
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}

